import formatCurrency from './formatCurrency';
export default formatCurrency;